// extracted by mini-css-extract-plugin
export default {"rawFallback":"RawFallback_rawFallback__VWJHS","rawFallbackNote":"RawFallback_rawFallbackNote__jjLab","rawFallbackContent":"RawFallback_rawFallbackContent__pWrtN"};